// @flow

import * as React from 'react';
import Plotly from 'plotly.js/lib/index-basic';

import withResponsive from '../utils/withResponsive';

type DataItem = {
  labels: string[],
  values: number[],
  text: string,
  color?: string,
};

type Props = {
  onRenderChart: (any) => mixed,
  data: DataItem[],
  options?: any,
};

class GroupedChart extends React.PureComponent<Props> {
  static defaultProps = {
    options: {},
  };

  componentDidMount() {
    if (this.el) {
      this.renderChart();
    }
  }

  componentDidUpdate() {
    if (this.el) {
      this.renderChart();
    }
  }

  getElementRef: Function = (el: HTMLDivElement) => {
    this.el = el;
    if (this.props.onRenderChart) {
      this.props.onRenderChart(el);
    }
  }

  el: HTMLDivElement;

  renderChart() {
    const data: Array<Object> = this.props.data.map((trace: DataItem): Object => ({
      x: trace.labels,
      y: trace.values,
      name: trace.text,
      type: 'bar',
      // width: 0.3,
      marker: {
        color: trace.color,
      },
    }));

    Plotly.newPlot(this.el, [...data], {
      paper_bgcolor: 'rgba(0,0,0,0)',
      plot_bgcolor: 'rgba(0,0,0,0)',
      barmode: 'group',
      margin: {
        t: 40,
        l: 50,
        r: 50,
        b: 120,
      },
      xaxis: {
        tickangle: -45,
        type: 'category',
      },
      legend: {
        orientation: 'h',
        x: 0,
        y: -0.32,
      },
      ...this.props.options,
    }, {
      showLink: false,
      displaylogo: false,
      sendData: false,
      modeBarButtonsToRemove: ['zoom2d', 'pan', 'pan2d', 'autoScale2d', 'sendDataToCloud', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'],
    });
  }

  render(): React.Node {
    return (
      <div ref={this.getElementRef} />
    );
  }
}

export default withResponsive<any>(GroupedChart);
